module.exports = __webpack_public_path__ + "img/shutterstock_655688416-web.a9effd89.png";